export const FETCH_REGULAR_BY_ORGANIZATION = 'FETCH_REGULAR_BY_ORGANIZATION'
export const CREATE_REGULAR_BY_ORGANIZATION = 'CREATE_REGULAR_BY_ORGANIZATION'
export const UPDATE_REGULAR_BY_ORGANIZATION = 'UPDATE_REGULAR_BY_ORGANIZATION'
export const DELETE_REGULAR_BY_ORGANIZATION = 'DELETE_REGULAR_BY_ORGANIZATION'
